<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card class="pa-2">
      <v-card-title>{{ $t("parts.inventory.actions.shareData") }}</v-card-title>
      <v-card-text class="pt-2 pb-4">
        <div class="share-options-grid">
          <button
            type="button"
            class="share-option"
            @click="shareWhatsApp"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
            </div>
            <span class="share-option-label">WhatsApp</span>
          </button>

          <!-- Subito Share -->
          <!-- <button
            type="button"
            class="share-option"
            @click="shareSubito"
          >
            <div class="share-option-icons">
              <img
                height="32"
                width="32"
                src="@/assets/icons/subito.png"
                alt="Subito"
              />
            </div>
            <span class="share-option-label">Subito</span>
          </button> -->
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import JSZip from "jszip";
import config from "../../config";

export default {
  components: {},
  data: () => ({
    dialog: false,
    carData: {},
  }),

  computed: {
    getUrl() {
      return `${config.getShopUri()}/share/car/${this.carData._id}`;
    },
  },

  methods: {
    open(data) {
      this.carData = data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    shareWhatsApp() {
      this.openWhatsAppShare(this.getUrl);
    },
    openWhatsAppShare(text) {
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
      const width = 800;
      const height = 500;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;

      window.open(
        url,
        "Share on WhatsApp",
        `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`,
      );
    },
    // shareSubito() {
    //   const xml = `
    //     <?xml version="1.0" encoding="UTF-8"?>
    //     <subito>
    //       <ad>
    //         <type>sell</type>
    //         <category>auto</category>
    //         <ad_code>${this.carData._id}</ad_code>
    //         <subject><![CDATA[ ${this.carData.brand.title} ]]></subject>
    //         <body>
    //           <![CDATA[ ${this.carData.brand.title} ${this.carData.model.description}
    //             DETTAGLI
    //             - Marca: ${this.carData.brand.title}
    //             - ${this.carData.model.fullDescription}
    //             - ${this.carData.version.fullDescription}
    //             - ${this.carData.version.supplyCode}
    //             - ${this.carData.transmissionType}
    //             - ${this.carData.chassisCode}
    //             - KM ${this.carData.km}
    //             - ${this.carData.externalColor}
    //             - Good state
    //           ]]>
    //         </body>
    //         <features>
    //           <geo>
    //             <town>
    //               <id>${this.carData.institution_id.city}</id>
    //             </town>
    //             <province>
    //               <id><![CDATA[ Italy ]]></id>
    //             </province>
    //           </geo>
    //           <price type="integer"> $$$$$$$ </price>
    //         </features>
    //         <advertiser>
    //           <email>${this.carData.institution_id.email}</email>
    //           <phone_hidden type="boolean">false</phone_hidden>
    //           <phone>${this.carData.institution_id.phone}</phone>
    //           <company type="boolean">true</company>
    //           <name><![CDATA[${this.carData.institution_id.title}]]></name>
    //         </advertiser>
    //         <images>
    //           <image>http://lekotech.com/logo.jpg</image>
    //         </images>
    //       </ad>
    //     </subito>
    //   `;
    //
    //   const zip = new JSZip();
    //   zip.file("data.xml", xml);
    //   zip.generateAsync({ type: "blob" }).then((result) => {
    //     const url = window.URL.createObjectURL(result);
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "subito.xml");
    //     document.body.appendChild(link);
    //     link.click();
    //   });
    // },
  },
};
</script>

<style scoped>
.share-options-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.share-option {
  display: flex;
  flex: 1 1 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  max-width: 200px;
  min-height: 110px;
  padding: 16px 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.share-option:hover {
  background-color: #fafafa;
  border-color: rgba(0, 0, 0, 0.24);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.share-option:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.share-option-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}

.share-option-label {
  font-size: 14px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  word-break: break-word;
}
</style>
